import { setCookie } from '@/shared/lib/utils/common/setCookie'

import { AI_UUID_COOKIE } from '../config/config'
import { ChatHistory } from '../model/schema'

import { createAiChatSession, getAiChatUuid } from './chat-session'

export interface AiChatMessagesResponse<T = unknown> {
	data: T
	page?: number
	per_page?: number
	total?: number
}

const DEFAULT_PAGE = 1
const DEFAULT_PAGE_SIZE = 20

export const fetchAiChatHistoryViaProxy = async (
	page: number = DEFAULT_PAGE,
	perPage: number = DEFAULT_PAGE_SIZE
): Promise<ChatHistory> => {
	await getAiChatUuid()
	const response = await fetch(`/api/ai-bot/ai-chat-history?page=${page}&perPage=${perPage}`)

	if (!response.ok) {
		// Если сессия не найдена - удаляем куку и создаём новую сессию
		if (response.status === 404) {
			setCookie(AI_UUID_COOKIE, '', { expires: new Date(0), path: '/' })
			const newUuid = await createAiChatSession()
			// Возвращаем пустую историю для новой сессии
			return {
				chat: {
					created_at: new Date().toISOString(),
					is_active: true,
					title: '',
					uuid: newUuid
				},
				messages: [],
				paging: { has_more: false, page: 1, next_page: 1 }
			}
		}
		throw new Error(`Failed to fetch AI chat history via proxy (${response.status})`)
	}

	const json = (await response.json()) as { data: ChatHistory }

	return json?.data
}
